import React from 'react';

function Footer() {
  return (
    <footer className="container mt-5 pt-4 pb-1 text-right text-small">
    </footer>
  );
}

export default Footer;